export default () => {
  const prevArrow = `
    <button class="thematic-categories__arrow thematic-categories__arrow--prev" type="button">
      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 2.18002L6 0.77002L0 6.77002L6 12.77L7.41 11.36L2.83 6.77002L7.41 2.18002Z" fill="white"/>
      </svg>
    </button>
  `

  const nextArrow = `
    <button class="thematic-categories__arrow thematic-categories__arrow--next" type="button">
      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 2.18002L6 0.77002L0 6.77002L6 12.77L7.41 11.36L2.83 6.77002L7.41 2.18002Z" fill="white"/>
      </svg>
    </button>
  `

  const selectors = {
    slider: '[js-thematic-categories="slider"]',
    barInner: '[js-thematic-categories="bar-inner"]',
  }

  function initSlider() {
    const slider = window.$(selectors.slider).slick({
      infinite: false,
      arrows: true,
      speed: 400,
      slidesToShow: 6,
      slidesToScroll: 3,
      prevArrow,
      nextArrow,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1630,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    })

    slider.on('beforeChange', (_event, slick, _currentSlide, nextSlide) => {
      const percent = (nextSlide / slick.slideCount) * 100

      if (percent >= 100) {
        window.$(selectors.barInner).css('left', '67%')
        return
      }

      window.$(selectors.barInner).css('left', `${percent}%`)
    })
  }

  function init() {
    if (!window.$(selectors.slider)) {
      return
    }

    initSlider()
  }

  return Object.freeze({
    init,
  })
}
